import type { UseQueryResult } from '@tanstack/react-query';
import type * as API from '@/api/interfaces';
import { createNamedContext } from '@/utils';

type ProjectDetailsContextValue = {
  query: UseQueryResult<API.Projects.FetchProject.Response>;
};

export const ProjectDetailsContext = createNamedContext<ProjectDetailsContextValue>(undefined, 'Project.Details.Context');
export const ProjectStateLoadingContext = createNamedContext<boolean>(undefined, 'Project.State.Loading.Context');